import React from 'react';
import { ListItem, Checkbox, TextField, IconButton, Tooltip, Chip } from '@mui/material';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
//import PlusOneOutlinedIcon from '@mui/icons-material/PlusOneOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Draggable } from 'react-beautiful-dnd';

const TodoItem = ({ 
  todo, 
  index, 
  handleToggleTodo, 
  handleEditTodo, 
  handleSaveTodo, 
  handleDeleteTodo, 
  handleDuplicateTodo,
  handleStartTimer,
  handleStopTimer,
  editingTodoIndex, 
  setTodos, 
  todos,
  isEditing,
  setIsEditing,
  editedDescription,
  setEditedDescription,
  activeTimers,
  totalTimeSpent,
  calculateOngoingTime
}) => (
  <Draggable draggableId={todo.id} index={index} isDragDisabled={editingTodoIndex === todo.id}>
    {(provided, snapshot) => (
      <ListItem
        ref={provided.innerRef}
        {...provided.draggableProps}
        style={{
          ...provided.draggableProps.style,
          display: 'flex',
          alignItems: 'center',
          background: snapshot.isDragging ? '#f5f5f5' : 'transparent',
          boxShadow: snapshot.isDragging ? '0 0 5px rgba(0,0,0,0.2)' : 'none',
        }}
      >
        <div {...provided.dragHandleProps} style={{ cursor: 'grab', marginRight: '8px' }}>
          <DragIndicatorIcon color="action" />
        </div>
    <Checkbox checked={todo.completed} onChange={() => handleToggleTodo(index)} />
    {editingTodoIndex === todo.id ? (
      <>
        <TextField
          autoFocus
          multiline
          style={{ width: '100%' }}
          defaultValue={todo.description}
          onChange={(e) => setEditedDescription(e.target.value)}
          onBlur={() => handleSaveTodo(todo.id, editedDescription)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSaveTodo(todo.id, editedDescription);
            }
          }}
        />
        <SaveOutlinedIcon onClick={() => handleSaveTodo(todo.id, editedDescription)} />
      </>
    ) : (
      <>

        <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
          <span onClick={() => handleEditTodo(index)} style={{ flexGrow: 1 }}>{todo.description}</span>
          
          {/* Display time spent for active timers or completed items */}
          {(activeTimers && activeTimers[todo.id]) ? (
            <Chip
              icon={<AccessTimeIcon />}
              label={calculateOngoingTime(todo.id)}
              size="small"
              color="primary"
              variant="outlined"
              sx={{ mt: 0.5, alignSelf: 'flex-start' }}
            />
          ) : todo.completed && (
            <Chip
              icon={<AccessTimeIcon />}
              label={
                todo.time_spent_text ? todo.time_spent_text :
                (totalTimeSpent && totalTimeSpent[todo.id] 
                  ? `${(totalTimeSpent[todo.id] / 1000 / 60).toFixed(1)} min` 
                  : "Time recorded")
              }
              size="small"
              color="success"
              variant="outlined"
              sx={{ mt: 0.5, alignSelf: 'flex-start' }}
            />
          )}
        </div>
        <Tooltip title="Edit this item" className="hide-on-mobile">
          <IconButton aria-label="Edit this item" className="hide-on-mobile" onClick={() => handleEditTodo(index)}>
            <EditNoteOutlinedIcon className="hide-on-mobile" />
          </IconButton>
        </Tooltip> 
        
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: 'auto' }}>
          {/* Timer button */}
          <IconButton 
            aria-label={activeTimers && activeTimers[todo.id] ? "Stop timer" : "Start timer"} 
            onClick={(e) => {
              e.stopPropagation();
              activeTimers && activeTimers[todo.id] 
                ? handleStopTimer(todo.id, true) // Pass true to mark as completed when stopping
                : handleStartTimer(todo.id);
            }}
            color={activeTimers && activeTimers[todo.id] ? "error" : "primary"}
            disabled={todo.completed} // Disable start button for completed items
          >
            {activeTimers && activeTimers[todo.id] ? <StopIcon /> : <PlayArrowIcon />}
          </IconButton>
          
          {/* Only show duplicate icon if todo doesn't have a running timer */}
          {!(activeTimers && activeTimers[todo.id]) && (
            <Tooltip title="Copy this item">
              <IconButton aria-label="Copy this item" onClick={() => handleDuplicateTodo(todo)}>
                <ContentCopyOutlinedIcon style={{ verticalAlign: 'middle' }} />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip title="Remove this item from the list">
            <IconButton 
              aria-label="Remove this item" 
              onClick={() => handleDeleteTodo(index)}
              disabled={activeTimers && activeTimers[todo.id]} // Disable delete when timer running
            >
              <DeleteOutlinedIcon style={{ verticalAlign: 'middle' }} />
            </IconButton>
          </Tooltip>
        </div>
      </>
    )}
      </ListItem>
    )}
  </Draggable>
);

export default TodoItem;
